import locale9ec66352 from '../..\\src\\locales\\en.json'

export const Constants = {
  COMPONENT_OPTIONS_KEY: "nuxtI18n",
  STRATEGIES: {"PREFIX":"prefix","PREFIX_EXCEPT_DEFAULT":"prefix_except_default","PREFIX_AND_DEFAULT":"prefix_and_default","NO_PREFIX":"no_prefix"},
  REDIRECT_ON_OPTIONS: {"ALL":"all","ROOT":"root","NO_PREFIX":"no prefix"},
}
export const nuxtOptions = {
  isUniversalMode: true,
  trailingSlash: undefined,
}
export const options = {
  vueI18n: {"fallbackLocale":"en","silentFallbackWarn":true},
  vueI18nLoader: false,
  locales: [{"code":"en","file":"en.json","name":"English"},{"code":"vn","file":"vn.json","name":"Tiếng Việt"}],
  defaultLocale: "en",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  defaultLocaleRouteNameSuffix: "default",
  sortRoutes: true,
  strategy: "no_prefix",
  lazy: true,
  langDir: "D:\\private\\personal-finance\\src\\locales",
  rootRedirect: null,
  detectBrowserLanguage: false,
  differentDomains: false,
  baseUrl: "",
  vuex: {"moduleName":"i18n","syncRouteParams":true},
  parsePages: true,
  pages: {},
  skipSettingLocaleOnNavigate: false,
  onBeforeLanguageSwitch: () => {},
  onLanguageSwitched: () => null,
  normalizedLocales: [{"code":"en","file":"en.json","name":"English"},{"code":"vn","file":"vn.json","name":"Tiếng Việt"}],
  localeCodes: ["en","vn"],
}

export const localeMessages = {
  'en.json': () => Promise.resolve(locale9ec66352),
  'vn.json': () => import('../..\\src\\locales\\vn.json' /* webpackChunkName: "lang-vn.json" */),
}
